import AboutSection from 'sections/about'
import BannerSection from 'sections/banner'
import ContactSection from 'sections/contact'
import ProjectsSection from 'sections/projects'

const Main = () => (
  <main>
    <BannerSection />
    <AboutSection />
    <ProjectsSection />
    <ContactSection />
  </main>
)

export default Main
